import GetMiniBasketRequestModel from '../../../generated/types/model/request/GetMiniBasketRequestModel';

export default class GetMiniBasketRequestViewModel extends GetMiniBasketRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
